export const GRAPHQL_VARIABLES = {
  page: 1,
  perPage: 10,
  filter: {}
};

export const QUERY = `
  query vendorsPagination ($page: Int, $perPage: Int, $filter: AutoFilledFilterFindManyvendorsInput, $sort: SortFindManyvendorsInput) {
    vendorsPagination (page: $page, perPage: $perPage, filter: $filter, sort: $sort) {
        count
        items {
            email
            phone
            firstName
            lastName
            companyName
            address {
                address1
                address2
                address3
                state
                city
                zip
                country
                _id
            }
            companyId
            bpCompany
            _id
            updatedAt
            createdAt
        }
        pageInfo {
            currentPage
            perPage
            pageCount
            itemCount
            hasNextPage
            hasPreviousPage
        }
    }
  }
`;
